var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"18","height":"12","fill":"none"}},[_c('path',{attrs:{"stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"2.271","d":"M16 6.36H2m0 0 4.307 4.36M2 6.36 6.307 2"}})])
}
var staticRenderFns = []

export default { render: render }